module.exports = __webpack_public_path__ + "static/media/menu.192bcee4.svg";